import { Navigate } from 'react-router';
import { useActiveLocation } from '../../hooks/useActiveLocation';
import ROUTES, { locationPath } from '../../routes/routeConstants';

// Resolves the bare /settings entry point to the active location's settings.
// Global settings subpages live at /settings/*, but the default landing is the
// first location-scoped subpage, so we redirect into /locations/:id/settings/*.
export function SettingsRedirect() {
  const { activeLocationId, isLoading } = useActiveLocation();

  if (isLoading) return null;

  if (!activeLocationId) {
    return <Navigate to={`/${ROUTES.locations}`} replace />;
  }

  return (
    <Navigate to={locationPath(activeLocationId, ROUTES.settings, ROUTES.settingsRooms)} replace />
  );
}
